"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
exports.default = (function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 899.43 800.39", className: classNames('sok-svg-icon', props.className) }),
    React.createElement("path", { fill: "#fff", d: "M319.72 242.63h252v474h-252z", "data-name": "Layer 9" }),
    React.createElement("path", { d: "M898.16 738.63q-4.7 25.79-25 43.75t-48.44 18h-750q-28.12 0-48.44-18t-25-43.75q-4.68-25.77 7.82-50.78l375-650q14.06-25 39.84-33.59a79.47 79.47 0 0 1 51.56 0q25.79 8.59 39.85 33.59l375 650q12.5 25.04 7.81 50.78zm-499.22-164q-21.09 21.09-21.09 50.78t21.09 50.78q21.09 21.11 50.78 21.1t50.78-21.1q21.09-21.09 21.1-50.78t-21.1-50.78q-21.09-21.11-50.78-21.11t-50.78 21.11zm-5.47-66.4q0 6.24 5.47 11.71a18.05 18.05 0 0 0 13.28 5.47h75a18.05 18.05 0 0 0 13.28-5.47q5.47-5.46 5.47-11.71l12.5-212.5q0-9.37-5.47-14.85a18.09 18.09 0 0 0-13.28-5.49h-100a18.09 18.09 0 0 0-13.28 5.47q-5.48 5.47-5.47 14.85z", fill: "#ffa300", "data-name": "Layer 10" }))); });
//# sourceMappingURL=ExclamationTriangle.js.map